import {
  ActionFunctionParams,
  basicBlockActions,
  MenuOption,
} from 'articleEditor/utils/actions';
import {
  insertNodes,
  removeNodes,
} from 'lib-knowledge-document-structure/plate/common';
import {
  MyBulletedListElement,
  MyBulletedListElementActual,
} from 'lib-knowledge-document-structure/plateTypes';
import { RenderElementProps } from 'lib-knowledge-document-structure/slate/react';
import { useMemo } from 'react';

import { SortableBlockWrapper } from '../baseBlock';
import s from '../baseBlock/block.module.scss';
import { convertUlToOl } from './unorderedListBlock.utils';

type UnorderedListBlockProps = RenderElementProps & {
  element: MyBulletedListElement;
};

export default function UnorderedListBlock({
  element,
  attributes,
  children,
}: UnorderedListBlockProps): JSX.Element {
  const blockActions = useMemo(
    () => [...basicBlockActions, ...transformBlockActions],
    [],
  );

  return (
    <SortableBlockWrapper
      className={s['blockUnorderedList']}
      element={element}
      blockActions={blockActions}
    >
      <UnorderedListComponent element={element} attributes={attributes}>
        {children}
      </UnorderedListComponent>
    </SortableBlockWrapper>
  );
}

type OrderedListComponentProps = RenderElementProps & {
  element: MyBulletedListElement;
};

function UnorderedListComponent({
  attributes,
  children,
}: OrderedListComponentProps) {
  return (
    <ul {...attributes} className={s['blockContent']}>
      {children}
    </ul>
  );
}

const transformBlockActions: ReadonlyArray<MenuOption> = [
  { key: 'heading', label: 'Convert to' },
  {
    key: 'ul',
    label: 'Bulleted List',
    icon: 'list-ul',
    isSelected: true,

    action: () => {},
  },
  {
    key: 'ol',
    label: 'Numbered List',
    icon: 'list-ol',
    isSelected: false,
    action: transformOlToUl,
  },
];

function transformOlToUl({ element, editor, path }: ActionFunctionParams) {
  const newElement = convertUlToOl(element as MyBulletedListElementActual);
  removeNodes(editor, { at: path });
  insertNodes(editor, newElement, { at: path });
}
